var exports = {
  "K": "icon__dInNXk",
};

module.exports = exports;
